import { subscription } from "@/services/datatypes/auth";
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(utc);
dayjs.extend(timezone);

export const useHasAccess = () => {
    const hasAccess = (subs: subscription[]): boolean => {
        if (!subs || subs.length === 0) return false;

        const currentDate = dayjs().tz("Europe/Berlin").startOf('day');

        return subs.some((s) => {
            return (
                s.type?.[0] === "EPAPER" &&
                s.start &&
                s.end &&
                isDateInRange(currentDate, s.start, s.end)
            );
        });
    };

    return { hasAccess };
};

function isDateInRange(
    date: dayjs.Dayjs,
    startUnix: number,
    endUnix: number
): boolean {
    const start = dayjs.unix(startUnix).startOf('day');
    const end = dayjs.unix(endUnix).endOf('day');

    return date.isSameOrAfter(start) && date.isSameOrBefore(end);
}
